import { useCallback, useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";

import PagedTable from "../../../shared/Tables/PagedTable";
import useBookingMutations from "../../../../data/useBookingMutations";
import { QuoteTabType } from "../../../../models/Lead";
import { ITableQuote } from "../../../../models/Quote";
import QuoteExpandedRow from "./QuoteExpandedRow";
import { getQuoteColumns } from "./quoteColumns";
import openInNewTab from "../../../../utils/openInNewTab";
import usePricingAccess from "../../../../hooks/usePricingAccess";

export default function QuotesTable({
  additionalBody,
  onTotalRowsChange,
} : {
  additionalBody?: Record<string, any>;
  onTotalRowsChange?: (totalRows: number) => void;
}) {
  const { updateQuoteTabType } = useBookingMutations("QuotesTable");
  const queryClient = useQueryClient();

  const onQuoteTabTypeChange = useCallback(
    (leadId: string, quoteTabType: QuoteTabType) => {
      updateQuoteTabType.mutate(
        { leadId, quoteTabType },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["pagedTable", "/quote"] });
          },
        }
      );
    },
    [updateQuoteTabType, queryClient]
  );

  const { canViewPrices } = usePricingAccess();
  const columns = useMemo(
    () => getQuoteColumns(onQuoteTabTypeChange, canViewPrices),
    [onQuoteTabTypeChange, canViewPrices]
  );

  return (
    <PagedTable<ITableQuote>
      columns={columns}
      url="/quote"
      // queryLabel="Search VRM"
      expandedRow={(quote: ITableQuote) => <QuoteExpandedRow quote={quote} />}
      onTotalRowsChange={onTotalRowsChange}
      additionalBody={{
        ...additionalBody,
      }}
      onRowClick={(quote) => {
        openInNewTab(`/bookings/${quote.id}`);
      }}
    />
  );
}